module.exports = __webpack_public_path__ + "static/media/0353_Medium.ebdf99ff.jpg";